// extracted by mini-css-extract-plugin
export default {"signing-link-container":"JbWV1iOl","signingLinkContainer":"JbWV1iOl","signing-link":"PlYTETr8","signingLink":"PlYTETr8"};